import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { useCombobox } from './ComboboxContext';
import messages from './Combobox.messages';

const ComboboxInput = ({ placeholder, prefix, suffix, className, disabled }) => {
  const intl = useIntl();
  const { inputRef, inputValue, onInputChange, onKeyDown, openDropdown, closeDropdown, isOpen } = useCombobox();

  return (
    <div
      className={`combobox__input-wrapper${isOpen ? ' combobox__input-wrapper--open' : ''}${
        disabled ? ' combobox__input-wrapper--disabled' : ''
      }${className ? ` ${className}` : ''}`}>
      {prefix && <span className="combobox__input-prefix">{prefix}</span>}
      <input
        ref={inputRef}
        className="combobox__input"
        type="text"
        placeholder={placeholder}
        value={inputValue}
        onChange={e => onInputChange(e.target.value)}
        onClick={disabled ? undefined : openDropdown}
        onKeyDown={disabled ? undefined : onKeyDown}
        role="combobox"
        aria-expanded={isOpen}
        aria-controls="combobox-listbox"
        aria-autocomplete="list"
        autoComplete="off"
        disabled={disabled}
      />
      {suffix && !disabled && (
        <button
          type="button"
          className="combobox__input-suffix"
          tabIndex={-1}
          onClick={isOpen ? closeDropdown : openDropdown}
          aria-label={intl.formatMessage(isOpen ? messages.toggleClose : messages.toggleOpen)}>
          {suffix}
        </button>
      )}
    </div>
  );
};

ComboboxInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
};

export default ComboboxInput;
